// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./jquery-global"
import "./jquery.smartTab.min"
// import "./easyticker"
// import "./jstree"
// import "./widget"
import "./app"
import './datatables'

// import './incident-datatable'
// import './reports_datatable'
// import "./overall_sla_status_datatable"
// import "./jquerysmarttab"

window.addEventListener('turbo:load', function() {
  $('.smarttab').smartTab({
    selected: 0,
    // theme: 'round', // basic, arrows, square, round, dots
    transition: {
                  animation:'slideHorizontal' // none|fade|slideHorizontal|slideVertical|slideSwing|css
                }
  });
})
